import { useMemo } from "react";
import { Create } from "react-admin";
import { useNotification } from "../../../common/hooks/useNotification";
import { v4 as uuidv4 } from "uuid";
import { EditActions } from "../../common/form/FormActions";
import { ApiClientForm } from "./ApiClientForm";

interface Props {}

export const ApiClientCreate = (props: Props) => {
  const notify = useNotification(props, "createSuccess");
  const initialClientId = useMemo(() => uuidv4(), []);
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.admin-flow-api-clients.title.create">
      <ApiClientForm initialClientId={initialClientId} />
    </Create>
  );
};
